export const getProtocol = (state) => state.protocol
export const getHistory = (state) => state.history
export const getProtocolItems = (state) => state.protocolItems
export const getTimeline = (state) => state.timeline